import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

import RadialChart1 from "./userpanelChart1";
import RadialChart2 from "./userpanelChart2";
import RadialChart3 from "./userpanelChart3";

const UserPanel = () => {
  const[company, setCompany] = useState("");
  const[email,setEmail] = useState('');
  const[allOrders, setAllorders] = useState([]);
  const[currenMonthorders, setCurrentmonthorders] = useState([]);
  const[previousMonthorders, setPreviousmonthorders] = useState([]);
  const[delivereOrders, setDeliveredorders] = useState([]);
  const[curentMonthdelivered, setCurrentmonthdelivered] = useState([]);
  const[previouseMonthdelivered, setPreviousmonthdelivered] = useState([]);
  const[allStores,setStores] = useState([]);
  const[thisMonthstores, setThismonthstores] = useState([]);
  const[lastMonthstores, setLastmonthstores] = useState([]);
  const[allCustomers, setAllcustomers] = useState([]);
  const[lastMonthcustomers, setLastmonthcustomers] = useState([]);
  const[thisMonthcustomers, setThismonthcustomers] = useState([]);
  const currentDate = new Date();
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Get the current month index and then get the name from the array
  const currentMonth = monthNames[currentDate.getMonth()];
  const [midnightTime, setMidnightTime] = useState(null);
  const [allOrderspercent, setAllorderspercent] = useState(0)
  const [deliveredPercent, setDeliveredpercent] = useState(0)
  const [storesPercent, setStorespercent] = useState(0)

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/profile', {
          credentials: 'include', // to send cookies
        });
        const data = await res.json();

        if (data.valid) {
          setEmail(data.email)
        } else {}
      } catch (error) {} 
    };

    fetchProfile();
  }, []);

  //get store id
  useEffect(()=>{
   const fetchData = async()=>{
      try{
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
        const data = await res.json();
        setCompany(data.company)
      }
      catch(err){}
   }

   if(email){
    fetchData();
   }
   
  },[email])

  useEffect(()=>{
    const getAllorders =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getAllorders?company=${company}`)
      const data = await res.json();
      setAllorders(data)
    }
    const getDeliveredorders =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getAlldelivered?company=${company}`)
      const data = await res.json();
      setDeliveredorders(data)
    }

    const getStoreserved =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getAllstoresserved?company=${company}`)
      const data = await res.json();
      setStores(data)
    }
    const getCustomersserved =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getAllcustomersserved?company=${company}`)
      const data = await res.json();
      setAllcustomers(data)
    }
    const getCurrentmonthorders =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getCurrentmonthorders?company=${company}`)
      const data = await res.json();
      setCurrentmonthorders(data)
    }

    const getCurrentmonthcustomers =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getCurrentmonthcustomers?company=${company}`)
      const data = await res.json();
      setThismonthcustomers(data)
    }
    const getCurrentmonthstores =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getCurrentmonthstores?company=${company}`)
      const data = await res.json();
      setThismonthstores(data)
    }
    const getPreviousmonthstores =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getPreviousmonthstores?company=${company}`)
      const data = await res.json();
      setLastmonthstores(data)
    }
    const getPreviousmonthcustomers =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getPreviousmonthcustomers?company=${company}`)
      const data = await res.json();
      setLastmonthcustomers(data)
    }
    const getPreviousmonthorders =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getPreviousmonthorders?company=${company}`)
      const data = await res.json();
      setPreviousmonthorders(data)
    }

    const getCurrentmonthdelivered =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getCurrentmonthdelivered?company=${company}`)
      const data = await res.json();
      setCurrentmonthdelivered(data)
    }
    const getPreviousmonthdelivered =async()=>{
      const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getPreviousmonthdelivered?company=${company}`)
      const data = await res.json();
      setPreviousmonthdelivered(data)
    }

    if(company){
      getAllorders();
      getCurrentmonthorders();
      getPreviousmonthorders()
      getCurrentmonthdelivered();
      getPreviousmonthdelivered();
      getDeliveredorders();
      getStoreserved();
      getCurrentmonthstores();
      getPreviousmonthstores();
      getCustomersserved();
      getCurrentmonthcustomers();
      getPreviousmonthcustomers();
    }

  },[company])

  useEffect(()=>{
    const dif = (((previousMonthorders.length - currenMonthorders.length)/previousMonthorders.length)*100);
    const per = 100 - dif;
    setAllorderspercent(per)


  },[currenMonthorders,previousMonthorders])

  useEffect(()=>{
    if(previouseMonthdelivered.length == 0){
      setDeliveredpercent(0)
    }
    else{
      const dif = (((previouseMonthdelivered.length - curentMonthdelivered.length)/previouseMonthdelivered.length)*100);
    const per = 100 - dif;
    setDeliveredpercent(per)

    }
    


  },[curentMonthdelivered,previouseMonthdelivered])

  useEffect(()=>{
    if(lastMonthstores.length == 0){
      setStorespercent(0)
    }
    else{
      const dif = (((lastMonthstores.length - thisMonthstores.length)/lastMonthstores.length)*100);
      const per = 100 - dif;
      setStorespercent(per)

    }
    


  },[lastMonthstores,thisMonthstores])


  return (
    <React.Fragment>
      <Row>
        <Col xl={3} sm={6}>
          <Card style={{backgroundColor:'#00910a'}}>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div id="radialchart-1" className="apex-charts" dir="ltr">
                    <RadialChart1 const percent = {allOrderspercent} />
                  </div>
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1" style={{color:'white'}}>{currentMonth} orders</p>
                  <h5 className="mb-3" style={{color:'white'}}>{currenMonthorders.length}</h5>
                  <p style={{color:'white'}}>Last month: {previousMonthorders.length}</p>
                  <p className="text-truncate mb-0" style={{color:'white'}}>
                    All orders:
                    <span className="text-warning me-2">
                      {" "}
                      {allOrders.length}
                     
                    </span>{" "}
                   
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card style={{backgroundColor:'#47b3ff'}}>
            <CardBody>
              <div className="d-flex">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <RadialChart2
                    id="radialchart-2"
                    className="apex-charts"
                    dir="ltr"
                    percent = {deliveredPercent}
                  />
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1" style={{color:'white'}}>{currentMonth} Delivered</p>
                  <h5 className="mb-3" style={{color:'white'}}>{curentMonthdelivered.length}</h5>
                  <p style={{color:'white'}}>Last month: {previouseMonthdelivered.length}</p>
                  <p className="text-truncate mb-0" style={{color:'white'}}>
                    All Delivered: 
                    <span className="text-warning me-2">
                      {" "}
                      {delivereOrders.length}{" "}
                    </span>{" "}
                    
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card style={{backgroundColor:'#4d47ff'}}>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <RadialChart3
                    id="radialchart-3"
                    className="apex-charts"
                    dir="ltr"
                    percent = {storesPercent}
                  />
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1" style={{color:'white'}}>{currentMonth} Stores</p>
                  <h5 className="mb-3" style={{color:'white'}}>{thisMonthstores.length}</h5>
                  <p style={{color:'white'}}>Last month: {lastMonthstores.length}</p>
                  <p className="text-truncate mb-0" style={{color:'white'}}>
                    All stores served:
                    <span className="text-warning me-2">
                      {" "}
                      {allStores.length}{" "}
                  
                    </span>{" "}
                    
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card style={{backgroundColor:'#ff47cb'}}>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-primary font-size-20">
                      <i className="ri-group-line"></i>
                    </div>
                  </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1" style={{color:'white'}}>{currentMonth} customers</p>
                  <h5 className="mb-3" style={{color:'white'}}>{thisMonthcustomers.length}</h5>
                  <p style={{color:'white'}}>Last month: {lastMonthcustomers.length}</p>
                  <p style={{color:'white'}} className="text-truncate mb-0">
                    All customers server:
                    <span className="text- me-2">
                      {" "}
                      {allCustomers.length}{" "}
                   
                    </span>{" "}
                   
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UserPanel;
